import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTimeAlwaysGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.73 17.035-.382-1.26a3.198 3.198 0 0 0 1.905-1.822h-9v4.767h29.494v-4.767h-3.429c-.404 1.437-1.453 2.608-2.854 3.082l-.381-1.26a3.198 3.198 0 0 0 1.904-1.822H19.584c-.404 1.437-1.453 2.608-2.855 3.082Zm17.517-4.406H19.766C19.766 10.076 17.8 8 15.386 8s-4.38 2.076-4.38 4.629h1.253c0-1.822 1.403-3.305 3.127-3.305 1.724 0 3.127 1.483 3.127 3.305H8V40h32V12.63h-4.5C35.5 10.076 33.536 8 31.12 8c-2.415 0-4.379 2.076-4.379 4.629h1.253c0-1.822 1.403-3.305 3.127-3.305 1.723 0 3.126 1.483 3.126 3.305ZM9.253 38.687h29.494V20.076H9.253v18.61Zm2.866-8.453 2.085 2.192 4.44-4.692-.883-.932-3.557 3.76-1.193-1.271-.892.943Zm9.16 0 2.085 2.192 4.44-4.692-.883-.932-3.557 3.76-1.203-1.271-.882.943Zm10.282 2.192-2.084-2.192.882-.943 1.202 1.271 3.558-3.76.882.932-4.44 4.692Z",
    fill: "currentColor"
  }));
}

export { SvgTimeAlwaysGlyph as default };
